// Every kiosk page refreshes itself while it is open: the owner ends a rental
// on the phone and the web should follow within a heartbeat or two without a
// reload. One interval that re-runs the page's OWN fetch — paused while the
// tab is hidden, never overlapping (a tick is skipped while the previous fetch
// is still in flight), cleared on unmount. `fn` should return its promise so
// the overlap guard can see it finish.
import { useEffect, useRef } from 'react';

export const REFRESH_MS = 30000;

export function useAutoRefresh(fn, ms = REFRESH_MS, enabled = true) {
  const fnRef = useRef(fn);
  fnRef.current = fn;
  const inFlight = useRef(false);

  useEffect(() => {
    if (!enabled) return undefined;
    const tick = async () => {
      if (document.hidden || inFlight.current) return;
      inFlight.current = true;
      try { await fnRef.current?.(); } catch { /* the page's fetch reports its own errors */ } finally { inFlight.current = false; }
    };
    const t = setInterval(tick, ms);
    const onVisible = () => { if (!document.hidden) tick(); };   // catch up as soon as the tab is shown again
    document.addEventListener('visibilitychange', onVisible);
    return () => { clearInterval(t); document.removeEventListener('visibilitychange', onVisible); };
  }, [ms, enabled]);
}
